import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Booking.css";

const menuItems = [
    {
        id: 1,
        title: "Online Pooja Booking",
        action: "Book Now",
        image: "./images/booking.png",
        link: "https://booking.sreepadmanabhaswamytemple.org/",
        external: true,
        group: "booking",
    },
    {
        id: 2,
        title: "Darshan Timing",
        action: "View",
        image: "./images/darshan-timing.png",
        link: "timing",
        group: "darshan",
    },
    {
        id: 3,
        title: "Attractions",
        action: "View",
        image: "./images/attraction.png",
        link: "attract",
        group: "darshan",
    },
    {
        id: 5,
        title: "E-Kanikka",
        action: "Donate",
        image: "./images/e-kanikka.png",
        link: "https://booking.sreepadmanabhaswamytemple.org/otherofferings.aspx",
        external: true,
        group: "donation",
    },
    {
        id: 5-1,
        title: "Kshethra Bhadratha Fund",
        action: "Donate",
        image: "./images/e-kanikka.png",
        link: "https://booking.sreepadmanabhaswamytemple.org/OtherOfferings.aspx?Pid=1&Vid=72",
        external: true,
        group: "donation",
    },
     {
        id: 5-2,
        title: "Goshala Donation",
        action: "Donate",
        image: "./images/e-kanikka.png",
        link: "https://booking.sreepadmanabhaswamytemple.org/Murajepam.aspx",
        external: true,
        group: "donation",
    },
     {
        id: 5-3,
        title: "Donate Golden Grace & Grandeur",
        action: "Donate",
        image: "./images/e-kanikka.png",
        link: "https://booking.sreepadmanabhaswamytemple.org/GoldenGrace.aspx",
        external: true,
        group: "donation",
    },
    {
        id: 6,
        title: "Festivals",
        action: "View",
        image: "./images/annadanam.png",
        link: "attract",
        group: "information",
    },
    {
        id: 7,
        title: "Onavillu Booking",
        action: "Book Now",
        image: "./images/onavillu.png",
        link: "https://booking.sreepadmanabhaswamytemple.org/onavill/Default.aspx",
        external: true,
        group: "booking",
    },
    {
        id: 8,
        title: "Tenders",
        action: "View",
        image: "./images/accommodation.png",
        link: "NewsEvents",
        group: "information",
    },
];


const groups = [
    {
        id: "booking",
        title: "Online Booking",
        subtitle: "Book temple services online",
        icon: "fa fa-calendar-check-o",
        className: "group-booking",
    },
    {
        id: "darshan",
        title: "Darshan & Explore",
        subtitle: "Timings and temple attractions",
        icon: "fa fa-arrow-right",
        className: "group-darshan",
    },
    {
        id: "donation",
        title: "Donation",
        subtitle: "Make your sacred offering",
        icon: "fa fa-inr",
        className: "group-donation",
    },
    {
        id: "information",
        title: "Temple Information",
        subtitle: "Festivals, tenders and updates",
        icon: "fa fa-info-circle",
        className: "group-information",
    },
];


function Booking() {

    const [activeGroup, setActiveGroup] = useState(null);

    const handleGroupClick = (groupId) => {

        if (activeGroup === groupId) {
            setActiveGroup(null);
        } else {
            setActiveGroup(groupId);
        }
    };


    const getGroupItems = (groupId) => {
        return menuItems.filter(
            item => item.group === groupId
        );
    };


    const renderService = (item, index) => {

        const content = (
            <div
                className="interactive-service-card"
                style={{
                    "--item-delay": `${index * 0.12}s`
                }}
            >

                <div className="service-image">

                    <img
                        src={item.image}
                        alt={item.title}
                    />

                </div>


                <div className="service-details">

                    <h3>
                        {item.title}
                    </h3>

                    <span>
                        {item.action}
                    </span>

                </div>


                <div className="service-arrow">

                    <i className="fa fa-arrow-right"></i>

                </div>

            </div>
        );


        if (item.external) {

            return (
                <a
                    key={item.id}
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="service-link"
                >
                    {content}
                </a>
            );

        }


        return (
            <Link
                key={item.id}
                to={item.link}
                className="service-link"
                onClick={() =>
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    })
                }
            >
                {content}
            </Link>
        );
    };


    return (

        <main className="interactive-booking-page">

            {/* Heading */}

            {/* <div className="interactive-heading">

                <span>
                    SREE PADMANABHASWAMY TEMPLE
                </span>

                <h1>
                    Temple Services
                </h1>

                <div className="heading-line">
                    <i className="fa fa-star"></i>
                </div>

                <p>
                    Choose a service to continue
                </p>

            </div> */}


            {/* Groups */}

            <div className="service-groups">

                {groups.map((group, index) => {

                    const isActive =
                        activeGroup === group.id;

                    const items =
                        getGroupItems(group.id);


                    return (

                        <div
                            key={group.id}
                            className={`
                                service-group-wrapper
                                ${isActive ? "active" : ""}
                            `}
                        >

                            {/* GROUP CARD */}

                            <button
                                className={`
                                    service-group
                                    ${group.className}
                                `}
                                onClick={() =>
                                    handleGroupClick(group.id)
                                }
                            >

                                <div className="group-icon">

                                    <i className={group.icon}></i>

                                </div>


                                <div className="group-content">

                                    <h2>
                                        {group.title}
                                    </h2>

                                    <p>
                                        {group.subtitle}
                                    </p>

                                </div>


                                {/* <div className="group-count">

                                    <span>
                                        {items.length}
                                    </span>

                                    <small>
                                        Services
                                    </small>

                                </div> */}


                                <div className="group-expand">

                                    <i
                                        className={`fa ${
                                            isActive
                                                ? "fa-chevron-up"
                                                : "fa-chevron-down"
                                        }`}
                                    ></i>

                                </div>

                            </button>


                            {/* EXPANDED SERVICES */}

                            {isActive && (

                                <div className="expanded-services">

                                    {items.map(renderService)}

                                </div>

                            )}

                        </div>

                    );

                })}

            </div>

        </main>
    );
}

export default Booking;